import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import {
  GENERATE_PRESIGNED_URL_FAILURE,
  GENERATE_PRESIGNED_URL_REQUEST,
} from '../../../actions/types';
import {
  fetchDataFromPresignedURL,
  generatePresignedUrl,
} from '../../../actions';
import { addNotification } from '../../../actions/ui';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  NotificationTypeEnum,
} from '../../../actions/ui/types';

export const generatePresignedUrlEpic: Epic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(GENERATE_PRESIGNED_URL_REQUEST),
    switchMap((action) => {
      return from(
        api.reportsCenterService.generatePresignedUrl(action.payload).pipe(
          mergeMap((response) =>
            of(
              generatePresignedUrl.success(response?.presignedUrl ?? []),
              fetchDataFromPresignedURL.request({
                presignedUrl: response?.presignedUrl,
              })
            )
          ),
          catchError((err) =>
            of(
              generatePresignedUrl.failure(err),
              addNotification({
                type: NotificationTypeEnum.ERROR,
                action: GENERATE_PRESIGNED_URL_FAILURE,
                body: 'error_messages.default',
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
              })
            )
          )
        )
      );
    })
  );

export default generatePresignedUrlEpic;
